import styled from "styled-components";

const InnerLayout = styled.div`
    padding: 4rem 15rem;
`;

const SectionStyled = styled.section`
    padding: 4rem 0;
`;
export {InnerLayout, SectionStyled}